export interface WithRemoved {
	removed?: boolean;
}

export function isPresent<T extends WithRemoved>(item: T): boolean {
	return !item.removed;
}
